import { render } from "./ConfigDocument.vue?vue&type=template&id=105b6536"
import script from "./ConfigDocument.vue?vue&type=script&lang=js"
export * from "./ConfigDocument.vue?vue&type=script&lang=js"

import "./ConfigDocument.vue?vue&type=style&index=0&id=105b6536&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__